import { CHANGE_ACCOUNT, CHANGE_BALANCE } from "../actions/walletAction";
const defaultState = {
  totalAccounts: null,
  selectedAccount: null,
  selectedAccountName: "",
  selectedAddress: "",
};

const walletReducer = (state = defaultState, action) => {
  switch (action.type) {
    case CHANGE_BALANCE:
      return {
        ...state,
        totalAccounts: action.totalAccounts,
        selectedAccount: action.selectedAccount,
      };
    case CHANGE_ACCOUNT:
      return {
        ...state,
        selectedAccount: action.selectedAccount,
        selectedAccountName: action.selectedAccountName,
        selectedAddress: action.selectedAddress,
      };
    default:
      return state;
  }
};

export default walletReducer;
